export const AFTER_DELETE = 'after-delete'
export const REDESIGN_FEEDBACK = 'redesign-feedback'
export const REASON_FOR_ARCHIVING = 'reason-for-archiving'
